(function($){


  //console.log(pn.settings.singleProductSettings);  
  

  $('table > tbody  > tr.cart-item').each(function(index, tr) { 
    

    console.log('test: ' + $(tr).data('pid') );
    

    if ( pn.settings.singleProductSettings.find( obj => obj.p == $(tr).data('pid') ) ) {
      
      //$('<span class="item-variant item-pre-order">test</span>').insertAfter($(tr).find('span.item-variant').last() );

      	
      var strPO = 'Pre Order Item';      
      var strETA = pn.settings.singleProductSettings.find( obj => obj.p == $(tr).data('pid') ).g;

      var intStock = pn.settings.singleProductSettings.find( obj => obj.p == $(tr).data('pid') ).s;
      
      console.log('s: ' + intStock);

      if (intStock <= 0) {

        if (strETA) {
          strPO = strPO + ' - ' + strETA;        
          $('<span class="item-variant item-pre-order">' + strPO + '</span>').insertAfter($(tr).find('span.item-variant').last() );

        }
        
      }
      
    }
   
    
  });

                  

  
  
  

  if ( $('#stock').hasClass('gts-out-of-stock') ) {
    $('.payment-options-container').hide(); 
  }
  

  $('#add-to-cart').bind('DOMSubtreeModified', function(e) {

    if (e.target.innerHTML.length > 0) {
      
      //console.log(e.target.innerHTML);
 
      if (e.target.innerHTML.toLowerCase().includes('pre order')) {

        var divStock = $('div#stock');
        var spanStock = $('div#stock span.stock');

        $(spanStock).text('Pre Order');    
        $(divStock).removeClass('gts-in-stock');
        $(divStock).addClass('gts-pre-order');

      }
            
    }
    
  });
 
  

  
  var gtmProduct = document.querySelector('#preorder-me-widget');
  var gtmProductSeed = gtmProduct.dataset.seed;

  
  console.log(gtmProductSeed);
  
  var gtmObjProduct = jQuery.parseJSON( gtmProductSeed );
  var gtmObjProductSKU = gtmObjProduct[0]['sku'];
  var gtmObjProductBarcode = gtmObjProduct[0]['barcode'];
  
  console.log('SKU:' + gtmObjProductSKU);
  console.log('Barcode:' + gtmObjProductBarcode);
  
  
  //$('#preorder-me-widget').data('seed', 'zebra');
  //$('#preorder-me-widget').data('seed','ZEBRA'); //set myvalue
  
  
  console.log('john goodman');
  

})(jQuery);